import ShopSupplierResourceModel from '../../generated/types/model/resource/ShopSupplierResourceModel';

export default class ShopSupplierResourceViewModel extends ShopSupplierResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
